import * as actionTypes from '../../Action/actionTypes';

const initialState = {
  branchesTable_data: {
    columns: [
      {
        label: 'Branch Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'Address',
        field: 'address',
        sort: 'asc'
      },
      // {
      //   label: 'Location',
      //   field: 'location',
      //   sort: 'asc'
      // },
      // {
      //   label: 'Subscription Number',
      //   field: 'subscription',
      //   sort: 'asc'
      // },
      // {
      //   label: 'View',
      //   field: 'viewlocation',
      //   sort: 'asc'
      // },
      {
        label: 'Building Count',
        field: 'building_count',
        sort: 'asc'
      },
      {
        label: 'QR Code',
        field: 'qr_code',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
    rows: []
  },
  branchData: [],
  departmentTable_data: {
    columns: [
      {
        label: 'Department ID',
        field: 'id',
        sort: 'asc'
      },
      {
        label: 'Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }
    ],
    rows: []
  },
  wifiTable_data: {
    columns: [
      {
        label: 'Wifi Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'Code',
        field: 'code',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }
    ],
    rows: []
  },
  departmentData: [],
  wifiData: [],

  // ------.
  branchCount: 0,
  departmentCount: 0,
  buildingsCount: 0,
  //  -------
};

const reducer=(state=initialState,action)=>{
  switch(action.type){
    case actionTypes.ADD_BRANCH:
      return {
        ...state,
        branchData: action.value
      };
    case actionTypes.ADD_DEPARTMENT:
      return {
        ...state,
        departmentData: action.value
      };
    case actionTypes.ADD_WIFIPACKAGE:
      return {
        ...state,
        wifiData: action.value
      };
    case actionTypes.ADD_TAGS_DASHBOARD:
      return {
        ...state,
        branchCount: action.value.branchCount,
        departmentCount: action.value.departmentCount,
        buildingsCount: action.value.buildingsCount,
      };
    case actionTypes.ADD_TAGS_DASHBOARD_SINGLE:
      return {
        ...state,
        [action.value.type]: action.value.data
      };
    default:
      return state;
  }
};

export default reducer;
